<template>
  <v-container>
    <Dialog
      @save="guardarDeuda"
      @close="close"
      :object="objEdit"
      :venta="venta"
      :deuda="deuda"
      :transaccion="transaccion"
      :show="abrirDialog"
    />
    <!-- <Indicadores :items="items" /> -->
    <template>
      <span class="align-center">
        Clientes con deudas
      </span>
    </template>
    <v-row>
      <v-col>
        <v-text-field
          class="text-xs-center"
          v-model="search1"
          append-icon="search"
          label="Búsqueda"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <Table
      @edit="editClick"
      :deuda="true"
      :headers="headers"
      :arrayList="clientes | conDeuda"
      :search="search1"
    />
    <template>
      <span class="align-center">
        Transacciones con deudas
      </span>
    </template>
    <v-row>
      <v-col>
        <v-text-field
          class="text-xs-center"
          v-model="search2"
          append-icon="search"
          label="Búsqueda"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
      <v-col>
        <v-autocomplete
          v-model="value"
          :items="itemsFiltro"
          outlined
          dense
          label="Filtrar por clientes"
          @change="selectClient()"
        ></v-autocomplete>
      </v-col>
    </v-row>
    <Table
      @detalle="detalleClick"
      :transacciones="true"
      :headers="headersDeudas"
      :arrayList="arrayList"
      :search="search2"
      :select="value"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Indicadores from "../components/dashboard/Indicadores";
import Chart from "@/components/base/charts/ChartVentas.vue";
import Table from "@/components/base/Table.vue";
import Dialog from "@/components/base/Dialog.vue";

export default {
  data() {
    return {
      search1: "",
      search2: "",
      arrProp: [],
      itemsFiltro: [],
      values: [],
      value: null,
      modoChart: "column",
      abrirDialog: false,
      deuda: false,
      transaccion: false,
      objEdit: {},
      headers: [
        { text: "Opciones", value: "opciones", sortable: false },
        { text: "Nombre", value: "nombre", sortable: true },
        { text: "Deuda", value: "deuda", sortable: true },
        { text: "Teléfono", value: "telefono", sortable: false },
        { text: "Email", value: "email", sortable: false },
      ],
      headersDeudas: [
        { text: "Opciones", value: "opciones", sortable: false },
        { text: "Persona", value: "persona", sortable: true },
        { text: "Total", value: "total", sortable: false },
        { text: "Pagado", value: "pagado", sortable: false },
        { text: "Diferencia", value: "monto", sortable: false },
        { text: "Deuda", value: "deuda", sortable: false },
        { text: "Fecha", value: "fecha", sortable: true },
      ],
      items: [
        {
          color: "warning",
          cuantity: `0`,
          title: "Deudas",
          artist: "Total adeudado",
        },
        {
          color: "success",
          cuantity: "0",
          title: "Balance",
          artist: "Ellie Goulding",
        },
      ],
      arrayList: [],
    };
  },
  components: {
    Indicadores,
    Chart,
    Chart: () =>
      new Promise((resolve) => {
        setTimeout(() => {
          resolve(Chart);
        }, 3000);
      }),
    Table,
    Dialog,
  },
  created() {
    this.llamarClientes();
    this.llamarVentas();
    this.llamarDeudas();
    this.llamarReporte();
    this.clientesFiltro();

    // this.calcularDeuda();
  },
  filters: {
    conDeuda: (clientes) => clientes.filter((c) => c.deuda > 0 || c.deuda < 0),
  },
  computed: {
    ...mapState("clienteNamespace", ["clientes"]),
    ...mapState("ventasNamespace", ["ventas", "venta"]),
    ...mapState("deudasNamespace", ["deudas", "reporteDeudas"]),
    ...mapState("usuarioNamespace", ["token"]),
  },
  methods: {
    ...mapActions("clienteNamespace", ["getClientes"]),
    ...mapActions("clienteNamespace", ["updateDeuda"]),
    ...mapActions("ventasNamespace", ["getVentas", "getVenta"]),
    ...mapActions("deudasNamespace", ["getDeudas", "getReporte"]),
    clientesFiltro() {
      this.itemsFiltro = this.clientes.map((i) => {
        let obj = {
          text: i.nombre,
          value: i._id,
        };
        return obj;
      });
    },
    ventaFn: () => (this.ventaProp = this.venta),
    totalDeudas() {
      let deudas = this.arrProp;
      let suma = 0;
      let text = ''
      deudas.forEach( i => {
        suma = (suma + i.total)
        })
      text = '$' + suma;
      this.items[0].cuantity = text;
    },
    async llamarReporte() {
      let Token = this.token;
      await this.getReporte(Token);
      this.arrProp = this.reporteDeudas;
      this.totalDeudas();
    },
    async llamarClientes() {
      let Token = this.token;
      await this.getClientes(Token);
    },
    async llamarDeudas() {
      let Token = this.token;
      await this.getDeudas(Token);
      this.arrayList = this.deudas;
    },
    async llamarVentas() {
      let Token = this.token;
      await this.getVentas(Token);
    },
    editClick(obj) {
      this.obj = {}
      this.objEdit = obj;
      this.transaccion = false;
      (this.deuda = true), (this.abrirDialog = true);
    },
    detalleClick(obj) {
      this.obj = {}
      this.objEdit = obj;
      this.transaccion = true;
      this.deuda = false;
      if (obj.venta) {
        this.getVenta({ id: obj.venta, token: this.token });
      }
      this.abrirDialog = true;
    },
    guardarDeuda(obj) {
      this.updateDeuda(obj);
      this.close();
      this.llamarClientes();
      this.llamarDeudas();
    },
    close() {
      this.abrirDialog = false;
    },
    selectClient() {
      debugger
      this.arrayList = [];
      if (this.value != null && this.value != "") {
        this.deudas.forEach((element) => {
          if (this.value == element.persona) {
            this.arrayList.push(element);
          }
        });
      }
      if (this.arrayList.length == 0) {
        this.arrayList = this.deudas;
      }
    },
  },
};
</script>
